module.exports = __webpack_public_path__ + "static/img/home_part5@2x.490331f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/home_part5@2x.jpg
// module id = bOuE
// module chunks = 0